/**
 * Paths available to users who are not logged in
 * @constant
 */
// import adminDashboardLayout from "pages/adminDashboard/adminDashboardLayout";

export const PUBLIC_PATHS = {
  LOGIN: "/user/login",
  SINGLE_SCRIPT: "/scripts/:slug",
  DASHBOARD: "/dashboard",
  SEARCH_RESULT: "/search/:text",
};

export const PROTECTED_PATHS = {
  USERS_CATEGORY: "/users-category",
  REGISTERED_USERS: "/registered-users",
  VERIFIED_USERS: "/verified-users",
  SUBSCRIBED_USERS: "/subscribed-users",
  ACTIVE_USERS: "/active-users",
  REVENUE: "/revenue",
  SINGLE_PURCHASES: "/single-purchases",
  WEEKLY_DOWNLOADS: "/downloads",
  TOTAL_REVENUE: "/totalrevenue",
  REVENUE_USD: "usd",
  REVENUE_NGN: "ngn",
  PAYMENT_OPERATIONS: "/payment-operations",
  PRODUCT_HEALTH: "/product-health",
  GROWTH_INTELLIGENCE: "/growth-intelligence",
  APPROVED_SCRIPTS: "/approved-scripts",
  SUBSCRIBERS: "/subscribers",
  UPLOAD_ADMIN: "/uploads-admin",
  NEW_EDIT_SCRIPT: "/new-edit-script",
  DASHBOARD: "/dashboard",
  SINGLE_SCRIPT: "/scripts/:slug",
  SEARCH_RESULT: "/search/:text",
  COMPOSER: "/composer",
  CATEGORIES: "/categories",
  LANGUAGES: "/languages",
  NEW_COMPOSER: "/composer/new",
  ALL_COMPOSER: "/all-composer",
  EDIT_COMPOSER: "/composer/:id",
};
